import { Injectable } from '@angular/core';
import {LoadingServiceInstance} from '../rxjs/rx_loading';
import {Subject} from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
    private readonly observable;
    constructor() {
        this.observable = new Subject();
        LoadingServiceInstance.setService(this);
    }

    getObservable() {
        return this.observable;
    }

    showLoading() {
        this.observable.next(true);
    }
    hideLoading() {
        this.observable.next(false);
    }
}
